import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarLoader from "../../common-components/CalendarLoader";
import {
  getCardIcon,
  getCardIconType,
  getCardTitle,
} from "../live-subs/mockSubscriptionData";

const LiveResolutionStat = ({ from }) => {
  const {
    liveResolutionStats,
    liveResolutionStatsError,
    liveResolutionStatsLoading,

    liveBCAResolutionStats,
    liveBCAResolutionStatsError,
    liveBCAResolutionStatsLoading,
  } = useSelector((state) => state.live);

  const isLoading =
    from === "pt_trial"
      ? liveResolutionStatsLoading
      : from === "bca"
      ? liveBCAResolutionStatsLoading
      : false;

  const [statsData, setStatsData] = useState({});

  const getFilteredStatsData = (data) => {
    const excludedKeys = ["total_bca_stuck"];

    if (!data || typeof data !== "object") return {};

    return Object.entries(data).reduce((filtered, [key, value]) => {
      if (!excludedKeys.includes(key)) {
        filtered[key] = value;
      }
      return filtered;
    }, {});
  };

  useEffect(() => {
    if (from === "pt_trial") {
      if (
        !liveResolutionStatsLoading &&
        !liveResolutionStatsError &&
        liveResolutionStats?.status
      ) {
        setStatsData(liveResolutionStats?.stats);
      } else {
        setStatsData({});
      }
    } else if (from === "bca") {
      if (
        !liveBCAResolutionStatsLoading &&
        !liveBCAResolutionStatsError &&
        liveBCAResolutionStats?.status
      ) {
        setStatsData(liveBCAResolutionStats?.stats);
      } else {
        setStatsData({});
      }
    }
  }, [
    liveResolutionStatsLoading,
    liveResolutionStatsError,
    liveResolutionStats,

    liveBCAResolutionStats,
    liveBCAResolutionStatsError,
    liveBCAResolutionStatsLoading,
  ]);

  return (
    <div
      className={`live-subscriptions mr-kpi-grid mt30 ${
        from === "bca" ? "grid-5" : "grid-4"
      }`}
    >
      {isLoading ? (
        <CalendarLoader daysCount={3} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(getFilteredStatsData(statsData))?.map(([key, data]) => {
          return (
            <div className="mr-kpi-card" key={key}>
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">
                    {getCardTitle(key, "pt_trial")}
                  </p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{data || 0}</div>
                  </div>
                </div>
                <span
                  className="mr-kpi-card-icon-container"
                  style={{
                    backgroundColor:
                      getCardIconType(key) === "blue"
                        ? "#dbeafe"
                        : getCardIconType(key) === "green"
                        ? "#d1fae5"
                        : getCardIconType(key) === "orange"
                        ? "#fed7aa"
                        : getCardIconType(key) === "red"
                        ? "#fee2e2"
                        : "#f3f4f6",
                    color:
                      getCardIconType(key) === "blue"
                        ? "#1e40af"
                        : getCardIconType(key) === "green"
                        ? "#065f46"
                        : getCardIconType(key) === "orange"
                        ? "#c2410c"
                        : getCardIconType(key) === "red"
                        ? "#dc2626"
                        : "#374151",
                  }}
                >
                  {getCardIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default LiveResolutionStat;
